const APP_DEFAULTS = {
    THIS_WEEK: "red",
    AWAITING: "yellow",
    LATER: "blue"
};

export const { THIS_WEEK, AWAITING, LATER } = APP_DEFAULTS;